export default "__VITE_ASSET__BaLLDjIa__"